// extracted by mini-css-extract-plugin
module.exports = {"jumbotron":"Jumbotron_jumbotron__SdHm4"};